import { Component, Mixins} from 'vue-property-decorator';
import DeviceWidthCheckerMixin from './deviceWidthChecker.mixin';

@Component
export default class Tooltip extends Mixins(DeviceWidthCheckerMixin) {
  public tooltipText: string = '';
  public styleObj = {};

  showTooltip(val: string, event: any) {
    this.tooltipText = val;
    const boundBox = event && event.target && event.target.getBoundingClientRect();
    const coordX = boundBox.left;
    const coordY = boundBox.top;
    this.styleObj = {
      top: (coordY + 45).toString() + 'px',
      left: (coordX +  (this.isMobile
        ? 0
        : 60)).toString() + 'px'
    };
  }

  hideTooltip() {
    this.tooltipText = '';
  }
}